import {Component, ViewChild} from '@angular/core';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';

@Component({
    selector: 'app-contact-box',
    templateUrl: './contact-box.component.html',
    styleUrls: ['./contact-box.component.scss']
})
export class ContactBoxComponent {
    readonly contactHrefSubjectTextId = 'contact_href_subject';
    readonly contactHrefBodyTextId = 'contact_href_body';

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    get contactHref() {
        let href = 'mailto:info@heringberlin.com';

        const subject = this.i18nDictionary.get(this.contactHrefSubjectTextId);
        let body = this.i18nDictionary.get(this.contactHrefBodyTextId);

        if (body != null) {
            body = ContactBoxComponent.replaceAll(body, '\\n', '\n');
        }

        const subjectAvailable = ContactBoxComponent.notNullOrEmpty(subject);
        const bodyAvailable = ContactBoxComponent.notNullOrEmpty(body);

        if (subjectAvailable || bodyAvailable) {
            href += '?';

            if (subjectAvailable) {
                href += 'subject=' + encodeURIComponent(subject);

                if (bodyAvailable) {
                    href += '&';
                }
            }
            if (bodyAvailable) {
                href += 'body=' + encodeURIComponent(body + '\n\n');
            }
        }

        return href;
    }

    private static replaceAll(value: string, searchValue: string, replaceValue: string) {
        return value.split(searchValue).join(replaceValue);
    }

    private static notNullOrEmpty(value: string | null): boolean {
        return value != null && value.trim().length > 0;
    }

}
